import { Box, Typography } from '@mui/material';
import { useGetAvailableIntegration } from 'apis/agency/integrations/hook';
import Button from 'components/Common/Button';
import Spinner from 'components/Common/Spinner';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, Outlet, useNavigate } from 'react-router-dom';

export default function Integration() {
  const navigate = useNavigate();

  const { data: integration, isLoading } = useGetAvailableIntegration();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Typography sx={{ cursor: 'pointer', alignItems: 'center' }} mb={2} onClick={() => navigate(-1)}>
        <FaArrowLeft /> Back to All apps
      </Typography>
      <Box bgcolor='white' p={3}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box>
            <img src={integration?.avatar_url} alt={integration?.name} />
            <Typography my={1} color='secondary' fontSize={14}>
              {integration?.description}
            </Typography>
          </Box>
          <Link to='configure'>
            <Button>Configure</Button>
          </Link>
        </Box>
      </Box>
      <Outlet />
    </>
  );
}
